const refConfig = {
  haotianfenxiao: 149,
  meike: 151,
  haotian: 152,
  huilianyi: 154,
  rongxin: 157,
  dingdingzhishu: 158,
  dingdingjijian: 160,
  dingdingyifang: 162,
  gongzhonghao: 170,
  qiyedaikai: 171,
  fengyue: 172,
  yunzhijia: 173,
  lianlian: 203,
  yikuaibao: 190,
  gaotu: 205,
};

module.exports = {
  refConfig,
};
